import { render, staticRenderFns } from "./tousu.vue?vue&type=template&id=69159dd2&scoped=true&"
import script from "./tousu.vue?vue&type=script&lang=js&"
export * from "./tousu.vue?vue&type=script&lang=js&"
import style0 from "./tousu.vue?vue&type=style&index=0&id=69159dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69159dd2",
  null
  
)

export default component.exports